import './SchoolSafetyStudentDashboard.css';

import * as React from 'react';
import { boundMethod } from 'autobind-decorator';
import { LessonProgress, MistakeBankLessons } from '../../../../services/elearn/lesson-types';

import BlogCard from '../BlogCard/BlogCard';
import LessonCard from '../LessonCard/LessonCard';
import Loading from '../../../../components/Loading/Loading';
import MindfulCard from '../MindfulCard/MindfulCard';
import MistakeBankCard from '../MistakeBankCard/MistakeBankCard';
import PDFCard from '../PDFCard/PDFCard';
import { PageContent } from '../../../../components/PageContent/PageContent';
import PracticeTests from '../PracticeTests/PracticeTests';
import { Progress } from '../Progress/Progress';
import { RouteComponentProps } from 'react-router-dom';
import StockCard from '../StockCard/StockCard';
import ReadyToLearn from '../ReadyToLearn/ReadyToLearn';
import TutorialCard from '../TutorialCard/TutorialCard';
import { UserInfo } from '../../../../services/account/account-rest-interface';
import { getBaseUrl } from '../../../../services/routing/routing-utils';
import { welcomeUser } from '../../../../services/account/account-rest-interface';
import WelcomeModalOne from '../WelcomeModalOne/WelcomeModalOne';
import WelcomeModalTwo from '../WelcomeModalTwo/WelcomeModalTwo';
import WelcomeModalThree from '../WelcomeModalThree/WelcomeModalThree';

import {
    SuperHelpfulTipsArray,
    MoreHelpfulResourcesArray,
    UnderstandingTheProcessArray
} from '../PDFCard/pdf-list';
import { StepByStepModal } from '../StepByStepModal/StepByStepModal';
import LessonStepByStepModal from '../LessonStepByStepModal/LessonStepByStepModal';
import { getUserLessonsOverview } from '../../../../stores/lesson.store';
import { getSSSDashboard } from '../../../../services/school-safety/school-safety-rest-interface';

export interface Props {

}

export interface DispatchProps {
  setUserInfo: (info: Partial<UserInfo>) => void;
}

export interface StoreProps {
    userInfo: UserInfo;
    numLessonsUnstarted: number;
    numLessonsCompleted: number;
    numLessonsStarted: number;
    currentLessonId: string;
    currentLesson: LessonProgress | undefined;
    mistake: MistakeBankLessons[];
    allLessons: LessonProgress[];
}

interface State {
    showFirstModal: boolean;
    showSecondModal: boolean;
    showThirdModal: boolean;
    showStepByStep: boolean;
    showLearnStepModal: boolean;
    isLoaded: boolean;
    myLessonData: any;
    myMistakeBankData: any;
}

export type AllProps = Props & StoreProps & DispatchProps & RouteComponentProps<any>;


export class StudentDashboard extends React.Component<AllProps, State> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
            showFirstModal: this.props.userInfo.postWelcome === 'true' ? false : true,
            showSecondModal: false,
            showThirdModal: false,
            showStepByStep: false,
            showLearnStepModal: false,
            isLoaded: false,
            myLessonData: {},
            myMistakeBankData: {}
        };
    }

    public componentDidMount() {
      getSSSDashboard().then((res) => {
          this.setState({
            isLoaded: true,
            myLessonData: {
                numLessonsCompleted: res.numLessonsCompleted,
                numLessonsStarted: res.numLessonsStarted,
                numLessonsUnstarted: res.numLessonsUnstarted
            },
            myMistakeBankData: {
                mbMastered: res.mbMastered,
                mbReview: res.mbReview,
                mbReviewAgain: res.mbReviewAgain
            },
         });
        });
    }

    public render() {
        const { numLessonsUnstarted, numLessonsCompleted, numLessonsStarted, userInfo, currentLessonId,
            currentLesson } = this.props;
        const { isLoaded, myLessonData, myMistakeBankData } = this.state;
        const name = userInfo.firstName;
        const totalLessons = numLessonsUnstarted + numLessonsCompleted + numLessonsStarted;

        // get all completed lesson info in mistake bank
        let missedLessons = [] as MistakeBankLessons[];

        const completeLessons = this.props.allLessons.filter(l => l.numCompletedQuestions === l.numTotalQuestions
                && (l.numTotalQuestions !== 0));
        const completeLessonsIds = completeLessons.reduce((acc: any, lesson: LessonProgress) => {
                acc.push(lesson.lessonId);
                return acc;
            }, []);

        missedLessons = this.props.mistake.filter((l) => {

                if(completeLessonsIds.includes(l.lessonId)) {
                    return true;
                } else {
                    return false;
                }
        });

        if (!isLoaded) {
            return <Loading />;
        }

        if(typeof(currentLesson) === 'undefined') {
            return <Loading />;
        }

        const hideInMobileViewClass = 'hidden-md-down';

        return (
            <PageContent className="home-container">

                {/* Welcome banner */}
                <div className="row">
                    <div className="col-12">
                        {name && <h1 className="page-title">Welcome, {name}</h1>}
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <Progress
                            totalLessons={totalLessons}
                            completedLessons={numLessonsCompleted}
                            lessonId={currentLessonId}
                            onLessonClick={this.onProgressLessonClick}
                            lesson={currentLesson}
                        />
                    </div>
                </div>

                {/* Cards */}
                <div className="row">
                    <div className="first-column col-lg-3 col-md-12 px-lg-0">
                        <LessonCard
                            completed={myLessonData.numLessonsCompleted}
                            current={myLessonData.numLessonsStarted}
                            total={myLessonData.numLessonsUnstarted}
                        />

                        <StockCard
                            btnText="CONTACT US"
                            bottomText="Have questions or feedback?"
                            topStyle=""
                            bottomStyle="bottom-text-contact"
                            btnLink="http://winwardacademy.com/contact/"
                            containerClass={hideInMobileViewClass}
                        />
                    </div>

                    <div className="col-lg-6 col-md-12">

                        <ReadyToLearn
                            btnText="VIEW MY LESSONS"
                            topText=""
                            bottomText="Are you ready to learn?"
                            topStyle="top-text"
                            bottomStyle="bottom-text"
                            btnClick={this.goToLesson}
                        />

                        <MindfulCard containerClass={hideInMobileViewClass} />

                    </div>

                    <div className="col-lg-3 col-md-12 px-lg-0">

                        <MistakeBankCard
                            mastered={myMistakeBankData.mbMastered}
                            reviewAgain={myMistakeBankData.mbReviewAgain}
                            review={myMistakeBankData.mbReview}
                        />

                        <BlogCard containerClass={hideInMobileViewClass} />
                    </div>
                </div>

                <WelcomeModalThree
                    show={this.state.showFirstModal}
                    onClose={this.sendPostWelcomed}
                />

                <StepByStepModal
                  show={this.state.showStepByStep}
                  onClose={this.closeStepByStep}
                  onModalClose={this.cancelStepModal}
                />

                <LessonStepByStepModal
                  show={this.state.showLearnStepModal}
                  onClose={this.closeLearnStepModal}
                />

            </PageContent>
        );
    }

    @boundMethod
    private goToLesson() {
      this.props.history.push(`${getBaseUrl()}app/lessons?view=subject`);
    }

    @boundMethod
    private toggleSecondModal() {
        this.setState({ showFirstModal: false });
        this.setState({ showSecondModal: true});
    }

    @boundMethod
    private toggleThirdModal() {
        this.setState({ showSecondModal: false });
        this.setState({ showThirdModal: true});
    }

    @boundMethod
    private openStepByStep() {
      this.setState({ showStepByStep: true });
    }

    @boundMethod
    private closeStepByStep() {
      this.setState({
        showStepByStep: false,
        showLearnStepModal: true
      });
    }

    @boundMethod
    private cancelStepModal() {
        this.setState({
            showStepByStep: false,
            showLearnStepModal: false
        });
    }

    @boundMethod
    private closeLearnStepModal() {
      this.setState({
        showLearnStepModal: false
      });
    }

    @boundMethod
    private onProgressLessonClick(lessonId: string) {
        this.props.history.push(`${getBaseUrl()}app/lessons/${lessonId}`);
    }

    @boundMethod
    private sendPostWelcomed() {
        welcomeUser(this.props.userInfo.id).then(this.updateInitialLogIn);
        this.setState({ showFirstModal: false, showSecondModal: false, showThirdModal: false });
    }

    @boundMethod
    private updateInitialLogIn() {
      this.props.userInfo.postWelcome = 'true';
    }
}
